import { Dialog } from "primereact/dialog";
import React from "react";

import { PrecalculatedAllowablesContent } from "./PrecalculatedAllowablesContent";

interface IPrecalculatedAllowablesModalProps {
  visible: boolean;
  onHide: () => void;
  accountId: string;
  payerId: number;
  caseSignature: string;
}

/**
 * Modal component to display precalculated allowables data
 * organized by provider specialty tabs, sorted by total pricing
 */
export function PrecalculatedAllowablesModal({
  visible,
  onHide,
  accountId,
  payerId,
  caseSignature,
}: IPrecalculatedAllowablesModalProps) {
  return (
    <Dialog
      header="Allowable Amount Calculation"
      visible={visible}
      onHide={onHide}
      style={{ width: "80vw" }}
      modal
      dismissableMask
    >
      <PrecalculatedAllowablesContent
        accountId={accountId}
        payerId={payerId}
        caseSignature={caseSignature}
        skip={!visible}
      />
    </Dialog>
  );
}
